// Copyright (c) 2023 Deere & Company

import DateCellRenderer from '../../shared/report-cell-renderers/date-cell-renderer';
import PinCellRenderer from '../../shared/report-cell-renderers/pin-cell-renderer';
import classNames from '../../shared/constants/ag-grid-class-names';
import dateFilterParams from '../../shared/constants/date-filter-params';
import {translate} from '../../../shared/services/translation-service';

export function getResponsibleDealerColumnDefinitions() {

    return [
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: PinCellRenderer,
            colId: 'pin',
            field: 'pin',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PIN'),
            width: 190
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'model',
            field: 'model',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('MODEL'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'description',
            field: 'description',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DESCRIPTION'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'modelYear',
            field: 'modelYear',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('MODEL_YEAR'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'deliveryDate',
            field: 'deliveryDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DELIVERY_DATE'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'openPips',
            field: 'openPips',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('OPEN_PIPS_Y_N'),
            width: 100
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'responsibleDealer',
            field: 'responsibleDealer',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('RESPONSIBLE_DEALER'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'customerName',
            field: 'customerName',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CUSTOMER_NAME'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'entityID',
            field: 'entityID',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('ENTITY_ID'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'activeWarranty',
            field: 'activeWarranty',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('ACTIVE_WARRANTY_Y_N'),
            width: 200
        }

    ];

}



// WEBPACK FOOTER //
// ./src/reports/responsible-dealer/report-services/column-definitions.js